import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { SupabaseProvider } from './utils/supabase';
import { initializeMonitoring } from './monitoring';
import App from './App';
import './i18n';
import './index.css';

// Initialize monitoring
initializeMonitoring();

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <SupabaseProvider>
        <App />
      </SupabaseProvider>
    </Suspense>
  </StrictMode>
);